import { Dispatch } from "redux";
import { setWarningMessage } from "../../Redux/Slices/alert.slice";

export const validateBranchData = (
  date: {
    branchName: string;
    branchAddress: string;
    branchEstablished: string;
    branchDesc: string;
  },
  dispatch: Dispatch
) => {
  const { branchName, branchAddress, branchEstablished, branchDesc } = date;

  if (!branchName) {
    dispatch(setWarningMessage("Please enter branch name."));
    return false;
  }

  if (!branchAddress) {
    dispatch(setWarningMessage("Please enter branch address."));
    return false;
  }

  if (!branchEstablished) {
    dispatch(setWarningMessage("Please enter established date."));
    return false;
  }

  if (!branchDesc) {
    dispatch(setWarningMessage("Please enter branch description."));
    return false;
  }

  return true;
};
